const couponStatus=function(index){
    switch (index) {
        case -1: return '待使用'
        case 1: return '已使用'
        case 2: return '已过期'
        default: return index
    }
}

const articleType=function(index){
    switch (index) {
        case 1: return '网站公告'
        case 2: return '游戏资讯'
        case 3: return '游戏攻略'
        default: return index
    }
}

const state=function(index){
    switch (index) {
        case -3: return '待提交/草稿'   //草稿
        case -2: return '未通过'
        case -1: return '待审核'
        case 0: return '不显示'
        case 1: return '显示'
        case 2: return '推荐'
        default: return index
    }
}

const gameType=function(index){
    switch (index) {
        case '1': return'消除'
        case '2': return'砖块'
        case '3': return'解谜'
        case '4': return'动作'
        case '5': return'模拟'
        case '6': return'飞行'
        case '7': return'射击'
        case '14': return'音乐'
        case '15': return'塔防'
        case '8': return'棋牌'
        case '17': return'卡牌'
        case '9': return'体育'
        case '10': return'拼图'
        case '11': return'字母'
        case '12': return'教育'
        case '16': return'点击'
        case '13': return'合集'
        case '18': return'其它'
        default: return index
    }
}

const examine_status=function(index){
    switch (index) {
        case -2: return '待提交/草稿'   //草稿
        case -1: return '待审核'
        case 2: return '已拒绝'
        default: return index
    }
}

const platform=function(index){
    switch (index) {
        case 1: return 'PC游戏'
        case 2: return 'Android游戏'
        default: return index
    }
}



export default {
    couponStatus,state,platform,articleType,gameType,examine_status
}